(ns frontend.view.grid.sale-agreements-grid.columns
  (:require [frontend.state.current-session :as session]))

;;default set of selected columns
(def ordered-default-columns
  [:sale-agreement/name
   :sale-agreement/customer
   :sale-agreement/won-by
   :common/created-on])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?                                             ;; TODO - read from schema ...
  #{:sale-agreement/name
    :sale-agreement/owner
    :sale-agreement/customer})
